module.exports = __webpack_public_path__ + "img/login-icon.46bf5c80.png";